if (!customElements.get("promo-countdown")) {
  class PromoCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Number(this.dataset.end) * 1000;
      if (!this.end) return;
      this.fields = {
        days: this.querySelector("[data-days]"),
        hours: this.querySelector("[data-hours]"),
        minutes: this.querySelector("[data-minutes]"),
        seconds: this.querySelector("[data-seconds]"),
      };
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const diff = Math.max(0, this.end - Date.now());
      const total = Math.floor(diff / 1000);
      const values = {
        days: Math.floor(total / 86400),
        hours: Math.floor((total % 86400) / 3600),
        minutes: Math.floor((total % 3600) / 60),
        seconds: total % 60,
      };
      Object.entries(values).forEach(([key, value]) => {
        if (this.fields[key]) {
          this.fields[key].textContent = String(value).padStart(2, "0");
        }
      });
      if (diff === 0) {
        clearInterval(this.interval);
        const ended = this.querySelector("[data-ended]");
        if (ended) {
          ended.hidden = false;
          this.querySelector("[data-timer]").hidden = true;
        }
      }
    }
  }
  customElements.define("promo-countdown", PromoCountdown);
}
